import { render, staticRenderFns } from "./HeadControlCabinet.vue?vue&type=template&id=77482d10&scoped=true"
import script from "./HeadControlCabinet.vue?vue&type=script&lang=js"
export * from "./HeadControlCabinet.vue?vue&type=script&lang=js"
import style0 from "./HeadControlCabinet.vue?vue&type=style&index=0&id=77482d10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77482d10",
  null
  
)

export default component.exports